export default "/images/e6c28952a8a6d6307e5e81889d85cd93.avif";